import React, { useEffect, useRef } from 'react';
const CHART_WIDTH = 980;
const CHART_HEIGHT = 610;
const WIDGET_CONFIG = {
  allow_symbol_change: true,
  calendar: false,
  details: true,
  hide_side_toolbar: false,
  hide_top_toolbar: false,
  hide_legend: false,
  hide_volume: false,
  hotlist: true,
  interval: '15',
  locale: 'en',
  save_image: true,
  style: '1',
  symbol: 'OANDA:XAUUSD',
  theme: 'dark',
  timezone: 'America/New_York',
  backgroundColor: '#0F0F0F',
  gridColor: 'rgba(242, 242, 242, 0.2)',
  watchlist: ['OANDA:XAUUSD', 'BINANCE:BTCUSDT', 'FOREXCOM:EURUSD', 'CAPITALCOM:NAS100', 'CAPITALCOM:SPX500'],
  withdateranges: true,
  compareSymbols: [],
  studies: ['STD;Trading%1Sessions'],
  autosize: false,
  width: CHART_WIDTH,
  height: CHART_HEIGHT
};
export function TradingViewChart() {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify(WIDGET_CONFIG);
    container.appendChild(script);
    return () => {
      container.innerHTML = '';
    };
  }, []);
  return <div className="w-full overflow-x-auto" data-id="element-95" data-mp="2un9xtecppewz">
      <div className="tradingview-widget-container mx-auto" ref={containerRef} style={{
      height: CHART_HEIGHT,
      width: CHART_WIDTH
    }} data-id="element-96" data-mp="2gxyb29ajw333">
        <div className="tradingview-widget-container__widget" style={{
        height: CHART_HEIGHT,
        width: CHART_WIDTH
      }} data-id="element-97" data-mp="2lqhsxig9tkdp" />
      </div>
    </div>;
}